import { render } from "./ContentProject.vue?vue&type=template&id=25234d5f"
import script from "./ContentProject.vue?vue&type=script&lang=js"
export * from "./ContentProject.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src895191040/src/tracker-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__